<style scoped>
.card-content.delivery-schedule {
  height: 200px;
  overflow-y: scroll;
}
</style>

<template lang="pug">
form(@submit.prevent='saveSettings')
  .row
    //- .col.s12
      p Delivery Modes
      ul
          li
              label(for='pickupMode')
                  input#pickupMode(type='checkbox', v-model='deliveryMode.pickup', @change='edited = true')
                  span Pickup
          li
              label(for='doorToDoorMode')
                  input#doorToDoorMode(type='checkbox', v-model='deliveryMode.doorToDoor',  @change='edited = true')
                  span Door-to-Door
    .col.s12
      p Delivery Schedule
    //- .col.s12.m4
      .card
          .card-content
              label(for='sameDayDelivery')
                  input#sameDayDelivery(type='checkbox', v-model='sameDayDeliverySetting.enabled', @change='edited = true')
                  span Same day delivery
          .divider
          .card-content.delivery-schedule(v-if='sameDayDeliverySetting.enabled')
              .vspace.small
              .row
                  .col.s12.input-field
                      textarea.materialize-textarea#sameDayDeliveryRemarks.form-control(type='text', v-model='sameDayDeliverySetting.remarks',  @change='edited = true')
                      label(for='sameDayDeliveryRemarks') Remarks
    .col.s12.m4
      .card
        .card-content
          label(for='rangeDelivery')
            input#rangeDelivery(
              type='checkbox',
              v-model='rangeDeliverySetting.enabled',
              @change='edited = true'
            )
            span Day range delivery
        .divider
        .card-content.delivery-schedule(v-if='rangeDeliverySetting.enabled')
          .vspace.small
          .row
            .col.s6.input-field
              //- input#dayRangeDeliveryFrom.form-control(
              //-   type='number'
              //-   v-model='rangeDeliverySetting.from'
              //-   @change='edited = true'
              //-   min='1'
              //-   required)
              //- label(for='dayRangeDeliveryFrom') From
              v-text-field#dayRangeDeliveryFrom(
                label='From',
                type='number',
                v-model='rangeDeliverySetting.from',
                @change='edited = true',
                min='1',
                required
              )
            .col.s6.input-field
              //- input#dayRangeDeliveryTo.form-control(
              //-   type='number',
              //-   v-model='rangeDeliverySetting.to',
              //-   @change='edited = true',
              //-   min='1',
              //-   required
              //- )
              //- label(for='dayRangeDeliveryTo') To
              v-text-field#dayRangeDeliveryTo(
                class,
                label='To',
                type='number',
                v-model='rangeDeliverySetting.to',
                @change='edited = true',
                min='1',
                required
              )
    //- .col.s12.m4
      .card
          .card-content
              label(for='scheduledDelivery')
                  input#scheduledDelivery(type='checkbox', v-model='scheduledDeliverySetting.enabled', @change='edited = true')
                  span Scheduled delivery
          .divider
          .card-content.delivery-schedule(v-if='scheduledDeliverySetting.enabled')
              .vspace.small
              .row
                  .col.s12.input-field
                      textarea.materialize-textarea#scheduledDeliveryRemarks(
                        type='text'
                        v-model='scheduledDeliverySetting.remarks'
                        @change='edited = true')
                      label(for='scheduledDeliveryRemarks') Remarks
    .col.s12.right-align(v-if='edited')
      .vspace.small
      a.btn-flat.waves-effect.waves-light(@click='clear') Revert Changes
      button.btn.waves-effect.waves-light Save
</template>
<script>
export default {
  data () {
    return {
      edited: false,
      settings: null,
      deliveryMode: {
        id: null,
        pickup: null,
        doorToDoor: null
      },
      sameDayDeliverySetting: {
        id: null,
        enabled: null,
        remarks: null
      },
      scheduledDeliverySetting: {
        id: null,
        enabled: null,
        remarks: null
      },
      rangeDeliverySetting: {
        id: null,
        enabled: null,
        from: null,
        to: null
      }
    }
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier || {}
    }
  },
  mounted () {
    this.getSettings()
  },
  watch: {
    supplier () {
      this.getSettings()
    }
  },
  methods: {
    getSettings () {
      if (this.supplier.id !== undefined) {
        this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
          this.$http
            .get(
              `${this.$config.API_URL}/suppliers/${this.supplier.id}/settings`
            )
            .then((result) => {
              this.settings = result.data
              this.parseSettings(this.settings)
              this.$M.updateTextFields()
            })
        })
      }
    },
    parseSettings (settings) {
      settings.forEach((setting) => {
        if (setting.propertyType === 'delivery:mode') {
          this.deliveryMode.id = setting.id
          this.deliveryMode.pickup = setting.propertyValue.includes('pickup')
          this.deliveryMode.doorToDoor
            = setting.propertyValue.includes('door-to-door')
        } else if (setting.propertyType === 'delivery:schedule:same_day') {
          this.sameDayDeliverySetting.enabled = true
          this.sameDayDeliverySetting.id = setting.id
          this.sameDayDeliverySetting.remarks = setting.propertyValue
        } else if (setting.propertyType === 'delivery:schedule:scheduled') {
          this.scheduledDeliverySetting.enabled = true
          this.scheduledDeliverySetting.id = setting.id
          this.scheduledDeliverySetting.remarks = setting.propertyValue
        } else if (setting.propertyType === 'delivery:schedule:range') {
          this.rangeDeliverySetting.enabled = true
          this.rangeDeliverySetting.id = setting.id
          let days = setting.propertyValue.split(';')
          this.rangeDeliverySetting.from = parseInt(days[0])
          this.rangeDeliverySetting.to = parseInt(days[1])
        }
      })
    },
    saveSettings () {
      let settingsToSave = []
      let settingsToDelete = []

      if (
        this.deliveryMode.id
        && !this.deliveryMode.pickup
        && !this.deliveryMode.doorToDoor
      ) {
        settingsToDelete.push(this.deliveryMode.id)
      } else if (this.deliveryMode.pickup || this.deliveryMode.doorToDoor) {
        settingsToSave.push({
          propertyType: 'delivery:mode',
          propertyValue:
            (this.deliveryMode.pickup ? 'pickup;' : '')
            + (this.deliveryMode.doorToDoor ? 'door-to-door;' : '')
        })
      }

      if (this.sameDayDeliverySetting.enabled) {
        settingsToSave.push({
          propertyType: 'delivery:schedule:same_day',
          propertyValue: this.sameDayDeliverySetting.remarks
        })
      } else if (this.sameDayDeliverySetting.id) {
        settingsToDelete.push(this.sameDayDeliverySetting.id)
      }

      if (this.scheduledDeliverySetting.enabled) {
        settingsToSave.push({
          propertyType: 'delivery:schedule:scheduled',
          propertyValue: this.scheduledDeliverySetting.remarks
        })
      } else if (this.scheduledDeliverySetting.id) {
        settingsToDelete.push(this.scheduledDeliverySetting.id)
      }

      if (this.rangeDeliverySetting.enabled) {
        settingsToSave.push({
          propertyType: 'delivery:schedule:range',
          propertyValue:
            this.rangeDeliverySetting.from + ';' + this.rangeDeliverySetting.to
        })
      } else if (this.rangeDeliverySetting.id) {
        settingsToDelete.push(this.rangeDeliverySetting.id)
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        let saveSettingsPromise = true
        let deleteSettingsPromise = true

        if (settingsToSave.length) {
          saveSettingsPromise = this.$http.post(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/settings`,
            {
              settings: settingsToSave
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
        }

        if (settingsToDelete.length) {
          deleteSettingsPromise = this.$http.delete(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/settings`,
            {
              params: {
                id: settingsToDelete
              },
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
        }

        Promise.all([saveSettingsPromise, deleteSettingsPromise])
          .then(() => {
            this.getSettings()
            this.edited = false
            this.$snackbar.success('Delivery options saved successfully')
          })
          .catch(() => {
            this.$snackbar.error('Could not save delivery options')
          })
      })
    },
    clear () {
      this.edited = false
      this.parseSettings(this.settings)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-settings-delivery.vue